<span class="label-action"
    [ngStyle]="{'border-color': label.group.color}"
>
    {{label.name}}
    <span
        title="Remove tag"
        class="label-action-btn"
        [ngClass]="style"
        (click)="action(label)"
    >
        {{actionText}}
    </span>
</span>
